module.exports = __webpack_public_path__ + "img/center_month.7d50e514.png";